import { Construction } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/Card';

export function ComingSoon({ title, description }: { title: string; description?: string }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col items-center justify-center py-16 text-center">
          <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-[#EFF6FF] text-[#2563EB]">
            <Construction className="h-8 w-8" />
          </div>
          <h3 className="text-lg font-medium text-[#1E293B]">功能建设中</h3>
          <p className="mt-2 max-w-md text-sm text-[#64748B]">
            {description ?? '该页面将在后续版本接入后端接口后正式上线。'}
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
